import React, { Component } from "react";
import { Link } from "react-router-dom";

export default class Footer extends Component {
  render() {
    return (
      <div>
        <footer
          class="footer has-background-black is-bold"
          style={{ borderTop: "solid 1px #363636" }}
        >
          <div class="content has-text-centered">
            <p>
              <strong style={{ color: "white" }}>© 2020 SpaceX Tracker</strong>{" "}
              by{" "}
              <a href="https://linkedin.com/in/ingus-jansons" target="_blank">
                Ingus Jansons
              </a>{" "}
              <br />
            </p>

            <p className="help" style={{ width: "80%", margin: "0 auto" }}>
              This is using the{" "}
              <a href="https://github.com/r-spacex" target="_blank">
                SpaceX-API
              </a>{" "}
              by r/SpaceX <br />{" "}
              <Link to="/credits">Open source attributions</Link> <br />
              <br /> We are not affiliated, associated, authorized, endorsed by,
              or in any way officially connected with Space Exploration
              Technologies Inc (SpaceX), or any of its subsidiaries or its
              affiliates. The names SpaceX as well as related names, marks,
              emblems and images are registered trademarks of their respective
              owners.
            </p>
          </div>
        </footer>
      </div>
    );
  }
}
